export default __webpack_public_path__ + "static/media/06_photo.6ede9258.jpg";